<template lang="pug">
  a(v-bind:href="url + '?code=' + this.param") {{ title }}
</template>

<script>
export default {
  props: ['title', 'url'],
  data: function() {
    return {
      param: '',
    };
  },
  methods: {
    setParam: function(param) {
      this.param = param.code;
    }
  },
  created() {
    let uri = window.location.href.split('?');
    if (uri.length == 2) {
      let vars = uri[1].split('&');
      let getVars = {};
      let tmp = '';
      vars.forEach(function(v){
        tmp = v.split('=');
        if(tmp.length == 2)
        getVars[tmp[0]] = tmp[1];
      });
      //console.log(getVars);
      // do
      this.setParam(getVars);
    }
  },
};
</script>